import { render, staticRenderFns } from "./creation-footer.vue?vue&type=template&id=2def4d64&scoped=true"
import script from "./creation-footer.vue?vue&type=script&lang=ts"
export * from "./creation-footer.vue?vue&type=script&lang=ts"
import style0 from "./creation-footer.vue?vue&type=style&index=0&id=2def4d64&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../.eden-mono/temp/node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.11.0_vue-template-compiler@2.7.16_webpack@5.102.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2def4d64",
  null
  
)

export default component.exports